export function EditIcon(props: React.SVGProps<SVGSVGElement>) {
  const color = props.color ?? '#3E4784'

  return (
    <svg fill="none" height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_5906_98289)">
        <path
          d="M9.16797 3.33027H5.66797C4.26784 3.33027 3.56777 3.33027 3.03299 3.60275C2.56259 3.84244 2.18014 4.22489 1.94045 4.69529C1.66797 5.23007 1.66797 5.93014 1.66797 7.33027V14.3303C1.66797 15.7304 1.66797 16.4305 1.94045 16.9652C2.18014 17.4356 2.56259 17.8181 3.03299 18.0578C3.56777 18.3303 4.26784 18.3303 5.66797 18.3303H12.668C14.0681 18.3303 14.7682 18.3303 15.3029 18.0578C15.7734 17.8181 16.1558 17.4356 16.3955 16.9652C16.668 16.4305 16.668 15.7304 16.668 14.3303V10.8303M6.66795 13.3303H8.0634C8.47105 13.3303 8.67488 13.3303 8.86669 13.2842C9.03675 13.2434 9.19932 13.176 9.34844 13.0847C9.51664 12.9816 9.66076 12.8375 9.94902 12.5492L17.918 4.58027C18.6083 3.88991 18.6083 2.77062 17.918 2.08027C17.2276 1.38991 16.1083 1.38991 15.418 2.08027L7.449 10.0492C7.16074 10.3375 7.01662 10.4816 6.91355 10.6498C6.82217 10.7989 6.75482 10.9615 6.714 11.1315C6.66795 11.3234 6.66795 11.5272 6.66795 11.9348V13.3303Z"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.66667"
        />
      </g>
      <defs>
        <clipPath id="clip0_5906_98289">
          <rect fill="white" height="20" width="20" />
        </clipPath>
      </defs>
    </svg>
  )
}
